<template>
  <div
      class="columns card is-vcentered"
      :class="`card-honrizontal${isArchive ? '-disabled' : ''}`"  >
    <div class="column is-2">
      <figure class="mgl-30px">
        <avatar :username="getUserName(contact)">
        </avatar>
      </figure>
    </div>
    <div class="column"
    :class="hasMoreInformations ? 'is-3' : 'is-7'">
        <p class="has-text-default">{{civilite(contact)}}</p>
        <span v-if="contact.prenom" class="title is-4 mgr-5px">{{contact.prenom}}</span>
        <span class="title is-4">{{contact.nom}}</span>
        <p class="has-text-secondary-icon">
          {{contact.fonction}}
        </p>
        <p class="has-text-secondary-icon">
          {{ typesContact }}
        </p>
        <p v-if="getLibelleContactsTiers" class="has-text-default">
          <qd-collapse
            :open="false"
            position="is-top"
            aria-id="contentIdForA11y4">
            <template #trigger="props">
                <a
                    aria-controls="contentIdForA11y4"
                    :aria-expanded="props.open">
                    {{ $t('detailContact.portail') }}
                    <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
                </a>
            </template>
            <p>
              <ul>
                <li v-for="contactTiers in listePortailTrie" :key="contactTiers.id">
                  <router-link-blank
                :to="{ name: 'c.bodac.clients/contacts-client',
                    params: {id: contactTiers.id}}"
                :message="contactTiers.nomCommercial"/>
                </li>
              </ul>
            </p>
        </qd-collapse>
        </p>
    </div>
    <div class="columns column is-multiline is-marginless is-paddingless">
      <div :class="hasMoreInformations ? 'column is-4' : ''">
        <p class="has-text-default">{{contact.telephone}}</p>
        <p class="has-text-default">{{contact.portable}}</p>
      </div>
      <div :class="hasMoreInformations ? 'column is-8' : ''">
        <p class="lien">{{contact.email}}</p>
      </div>
    </div>
    <div class="column is-3 columns">
      <router-link :to="{ name: 'c.bodac.clients/contacts-contacts',
          params: {id: contact.id, isFromBailleur: isFromBailleur }}"
        class="column is-2 button-detail-contact"
        :class="{'text-access-no-permission':  !checkPermissions(permsTiers.lecture)}">
        <b-icon
            icon="account"
            type="is-primary">
        </b-icon>
      </router-link>
        <div class="column is-2 button-detail-contact"
          v-if="contact.accesPortail">
          <b-tooltip :label="$t('editionContact.messages.accesPortail')">
            <b-icon icon="web" type="is-warning"></b-icon>
          </b-tooltip>
        </div>
      <a @click="inProgress()" class="column is-2 button-detail-contact">
        <b-icon
          icon="email">
        </b-icon>
      </a>
      <a v-if="!isPortail" @click="checkPermissions(permsTiers.maj)
                ? modifierContact(contact) : showPopUp()"
          class="column is-2 button-detail-contact">
        <b-icon
          icon="pencil-box-outline"
          type="is-success"
          :class="{
                'text-access-no-permission' : !checkPermissions(permsTiers.maj)
                }"
        >
        </b-icon>
      </a>
      <archive-list-button v-if="!isPortail"
        class="column is-2 button-detail-contact"
        :query="() => archiver([contact.id])"
        :permissions="permsTiers.supprimer"
        :title="$t(`general.archiver.${contact.archive ? 'reactive': 'titre'}`,
            { type: $t('supprimerContact.type') })"
        :successMessage="$t('archiverContact.archiveSuccess')"
        @done="$emit('archive', contact.id)"
        :actif="!contact.archive"/>
      <delete-list-button v-if="!isPortail"
        class="column is-2 button-detail-contact"
        :query="() => remove(contact.id)"
        :validation="validation"
        :permissions="permsTiers.supprimer"
        :title="$t('general.suppression.titre', { type: $t('supprimerContact.type') })"
        :subtitle="$t('general.suppression.sousTitre')"
        :successMessage="$t('detailBailleur.messages.suppressionDone')"
        :disabled="!!contact.utilisateurId"
        @done="$emit('remove', contact.id)"
        :tooltipLabel="contact.utilisateurId
        ? $t('editionContact.messages.deleteContactUtilisateur')
        : null"
        />
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Avatar from 'vue-avatar';
import messageErreur from '@/services/general/messageErreur';
import { TIERS } from '@/configuration/permissionsBodacConf';
import inProgress from '@/services/general/inProgress';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { remove, archiver } from '@/api/contacts';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import validation from '@/services/contact/validation';
import archiveListButton from '@/components/general/button/archiveListButton';
import deleteListButton from '@/components/general/button/deleteListButton';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'ContactCard',
  props: {
    contact: {
      type: Object,
      required: true,
    },
    isFromBailleur: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPortail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      permsTiers: TIERS,
      remove,
      archiver,
      validation,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    hasMoreInformations() {
      return this.contact.email || this.contact.telephone || this.contact.portable;
    },
    civilites() {
      return this.parametre(PARAMETRES_KEYS.civilite);
    },
    listeTypesContact() {
      return this.parametre(PARAMETRES_KEYS.typeContact);
    },
    isArchive() {
      return this.contact.archive;
    },
    listePortailTrie() {
      const contacts = [...this.contact.contactsTiers];
      // Trier la liste par nomCommercial croissant
      contacts.sort((a, b) => a.nomCommercial.localeCompare(b.nomCommercial));
      return contacts;
    },
    getLibelleContactsTiers() {
      if (this.isFromBailleur
      || this.contact.contactsTiers === null
      || this.contact.contactsTiers === undefined
      || this.contact.contactsTiers.length === 0) {
        return null;
      }
      const nomsCommerciaux = this.contact.contactsTiers
        .map(c => c.nomCommercial);
      return nomsCommerciaux.join(', ');
    },
    typesContact() {
      return cloneDeep(this.contact).typesContactIds.map((id) => {
        const typeLibelle = this.listeTypesContact.find((element) => {
          return id === element.id;
        })?.libelle;
        return typeLibelle;
      }).join(', ');
    },
  },
  components: {
    Avatar,
    archiveListButton,
    routerLinkBlank,
    deleteListButton,
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getUserName(contact) {
      return nomPrenomGetter(contact);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    civilite(contact) {
      if (!contact.civiliteId) return '';
      const civlib = this.civilites.find((element) => {
        return contact.civiliteId === element.id;
      })?.libelle;
      return civlib;
    },
    modifierContact(contact) {
      this.$emit('edit', contact);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.typeContact,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
